import { createSlice } from "@reduxjs/toolkit";

export const DivisionSlice = createSlice({
  name: "division",
  initialState: JSON.parse(localStorage.getItem("division")) || {
    code: "BOI",
    name: "boise",
  },
  reducers: {
    setDivision: (state, action) => {
      state = action.payload;
      const division = action.payload;
      division.name = action.payload?.name.toLowerCase();
      localStorage.setItem("division", JSON.stringify(division));
    },
  },
});

export const selectedDivision = (state) => state.division;
export const { setDivision } = DivisionSlice.actions;
export default DivisionSlice.reducer;
